export default {
  backFlag: false, // 编辑状态
  isEditPage: false, // 是否在编辑页
  hasNewVersion: false,// 是否有新版本
}
